define('home/views/EmbedContainerView',[
    'jquery',
    'underscore',
    'backbone-marionette',

    'core/switches',
    'core/utils/url/serialize',
    'core/WindowBus',

    'home/utils/embed',

    'home/templates/embedContainer',
    'home/mixins/withAllstarPopover',
], function (
    $,
    _,
    Marionette,

    switches,
    serialize,
    WindowBus,

    embedUtils,

    embedContainerTemplate,
    withAllstarPopover
) {
    'use strict';

    var windowBus = new WindowBus();

    var CATEGORY_TO_ADS_FORUM = {
        'business': ['disqus-business', '4082353'],
        'celebrity': ['disqus-arts-entertainment', '4082366'],
        'culture': ['disqus-society', '4082367'],
        'entertainment': ['disqus-arts-entertainment', '4082366'],
        'games': ['disqus-hobbies-interests', '4082372'],
        'living': ['disqus-health-fitness', '4082385'],
        'news': ['disqus-news', '4082391'],
        'sports': ['disqus-sports', '4082395'],
        'style': ['disqus-style-fashion', '4082396'],
        'tech': ['disqus-technology-computing', '4082399'],
    };

    function getAdConfig(thread) {
        // home_ads_prevented is an exception list managed in jones. Only display ads if not on
        // the exception list, and the site is qualified to run ads.
        var allowChannelAds = switches.isFeatureActive('home_ads', { channelDiscussions: true });

        var displayAds = !switches.isFeatureActive('home_ads_prevented', { forum: thread.forum.id }) &&
            (thread.forum.get('adsReviewStatus') === 1 || thread.forum.channel && allowChannelAds);

        if (!displayAds)
            return {};

        var category = thread.forum.get('category').toLowerCase();
        var forumFromCategory = CATEGORY_TO_ADS_FORUM[category] || CATEGORY_TO_ADS_FORUM.entertainment;
        var provider = 'prebid';
        var experiment = 'adsnative_ui';
        var variant = 'baseline_2016';

        var basePlacementParams = {
            'an_version': 1,
            'adx': 1,
            'aol': 1,
            'appnexus': 1,
            'category': category,
            'display_bidding_enabled': 1,
            'doublewide_allowed': 1,
            'experiment': experiment,
            'forum_pk': forumFromCategory[1],
            'openx': 1,
            'provider': provider,
            'rubicon': 1,
            'serverbid': 1,
            'service': 'dynamic',
            'shortname': forumFromCategory[0],
            'stories_allowed': 1,
            'variant': variant,
            'video_allowed': 0,
        };

        var topPlacementParams = _.extend({ position: 'top' }, basePlacementParams);
        var topPlacementUrl = serialize('https://disqusads.com/ads-iframe/' + provider + '/', topPlacementParams);

        var bottomPlacementUrl = '';
        if (switches.isFeatureActive('home_ads', { bottomPlacement: true })) {
            var bottomPlacementParams = _.extend({ position: 'bottom' }, basePlacementParams);
            bottomPlacementUrl = serialize('https://disqusads.com/ads-iframe/' + provider + '/', bottomPlacementParams);
        }

        return {
            bin: ['embed', 'promoted_discovery', 'dynamic', experiment, variant].join(':'),
            experiment: experiment,
            forum_id: forumFromCategory[1],
            service: 'dynamic',
            variant: variant,
            top_placement_url: topPlacementUrl,
            bottom_placement_url: bottomPlacementUrl,
        };
    }

    function disqusConfig(thread, sortOrder) {
        var embedConfig = this;

        embedConfig.discovery = {
            disable_all: true,
        };
        embedConfig.forum = thread.forum.id;
        embedConfig.page.slug = thread.get('slug');
        embedConfig.page.title = thread.get('title');
        embedConfig.page.url = thread.get('link');
        embedConfig.experiment.force_auto_styles = true;
        embedConfig.experiment.enable_scroll_container = true;
        if (sortOrder)
            embedConfig.experiment.sort_order = sortOrder;
        embedConfig.callbacks.onNewComment.push(embedUtils.onEmbedComment);
        embedConfig.server_side = getAdConfig(thread);

        embedConfig.callbacks.onReady = [function (_data, frame) {
            // Scroll has an offset of 90px to give some breathing room
            // between the Embed frame and the Home navbar
            if (window.document.location.hash === '#disqus_thread')
                window.scrollTo(0, $(frame.elem).offset().top - 90);
        }];
    }


    var EmbedContainerView = Marionette.ItemView.extend({
        template: embedContainerTemplate,

        initialize: function (options) {
            this.sortOrder = options && options.sortOrder;

            // posts.create messages comes directly from the embed when a user makes a comment
            this.listenTo(windowBus, 'click:allstar', this.showAllstarModal);
        },

        onShow: function () {
            // Thread must be fetched before loading the embed.
            // This prevents issues where the embed will be reset multiple times when
            // a discussion page is loaded directly, as well as issues where some of
            // the config settings are not accurate.
            if (!this.model.id)
                return;

            window.DISQUS.reset({
                reload: true,
                config: _.partial(disqusConfig, this.model, this.sortOrder),
            });
        },
    });

    withAllstarPopover.call(EmbedContainerView.prototype);

    return EmbedContainerView;
});


